module.exports = __webpack_public_path__ + "media/src/assets/images/analytics-fingertips-image-f72c2dc29ac9b997c388aa8ea6ef03bc.svg";